<template>
  <div class="content">
        <!-- <p class="text-white bg-info rounded" style="padding: 1em;"><b>New Version is available.</b> Would you like to update now? <button type="button" class="btn btn-primary" style="margin-left:50em;">Large button</button>
</p> -->

    <transition name="fade" mode="out-in">
      <!-- your content here -->
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
  export default {}
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
